"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:6.6.0'] && _();
}
catch (e) { }
